import React, { Component } from 'react';
import * as $ from 'jquery';
import spinner from '../../images/loading-spinner.gif';
import { EVENT_DATE } from './EventsContainer.js';
import { translate } from 'react-i18next';

class EventSearch extends Component {

  renderCenter = (center, index) => {
    return (
      <li key={index}>
        <a onClick={() => this.props.handleCenterClick(center)}>
          {center.name}
        </a>
      </li>
    );
  }

  render() {
    const { t } = this.props;
    const center = this.props.center;

    return (
      <div className="jumbotron panel-resvations-events">
        <div className="row">
          <div className="col-md-6">
            <form method="post" onSubmit={this.props.handleEventSearch}>
              <fieldset>
                <div className="form-group">
                  <label htmlFor="center">
                    {t('dashboard.events.label_center')}
                  </label>
                  <div id="dropdown-div" className="dropdown">
                    <input
                      autoComplete="off"
                      className="dropdown-toggle form-control"
                      data-toggle="dropdown"
                      id="center"
                      onChange={this.props.handleCenterSearch}
                      onClick={() => { $("#dropdown-div").addClass("open") }}
                      placeholder={t('dashboard.events.holder_center')}
                      type="search"
                      value={this.props.centerQuery} />
                    <ul id="center-results" className="dropdown-menu" style={{ display: 'none' }}>
                      {this.props.centers.map((center, index) => this.renderCenter(center, index))}
                    </ul>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="event">
                    {t('dashboard.events.label_event')}
                  </label>
                  <input
                    className="form-control"
                    id="event"
                    onChange={this.props.handleEventQuery}
                    placeholder={t('dashboard.events.holder_event')}
                    type="text"
                    value={this.props.eventQuery} />
                </div>
                <div className="form-group">
                  <label htmlFor="date">
                    {t('dashboard.events.label_date')}
                  </label>
                  <select
                    className="form-control"
                    id="date"
                    onChange={this.props.handleDateChange}
                    value={this.props.date}>
                    <option value={EVENT_DATE.ANY}>{t('dashboard.events.date_any')}</option>
                    <option value={EVENT_DATE.TODAY}>{t('dashboard.events.date_today')}</option>
                    <option value={EVENT_DATE.TOMORROW}>{t('dashboard.events.date_tomorrow')}</option>
                    <option value={EVENT_DATE.WEEKEND}>{t('dashboard.events.date_weekend')}</option>
                    <option value={EVENT_DATE.WEEK}>{t('dashboard.events.date_week')}</option>
                    <option value={EVENT_DATE.NWEEK}>{t('dashboard.events.date_nweek')}</option>
                    <option value={EVENT_DATE.MONTH}>{t('dashboard.events.date_month')}</option>
                    <option value={EVENT_DATE.NMONTH}>{t('dashboard.events.date_nmonth')}</option>
                  </select>
                </div>
                <div className="form-group">
                  <button
                    className="btn btn-primary btn-search-events"
                    disabled={this.props.isSearching}
                    type="submit">
                    {t('dashboard.events.btn_search')}
                  </button>
                  <div className={this.props.isSearching ? "demo-container" : "hidden"}>
                    <div className="progress-bar">
                      <div className="progress-bar-value"></div>
                    </div>
                  </div>
                </div>
                <div className={this.props.error ? "" : "hidden"}>
                  <div className="form-group">
                    <div className="alert alert-warning">
                      {this.props.error}
                      <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <div className="col-md-6">
            <div className="iframe-wrapper">
              <iframe
                frameBorder="0"
                src={
                  "https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k&ll="
                  + (center ? center.latitude : "0")
                  + "%2C"
                  + (center ? center.longitude : "0")
                }
                title={t('dashboard.events.frame_center')}>
              </iframe>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(EventSearch);



// WEBPACK FOOTER //
// ./src/dashboard/events/EventSearch.js